
            const data = {"name":"ic-red","data":{"width":"7","height":"26","viewBox":"0 0 7 26","data":"<path pid=\"0\" _fill=\"#FF324B\" d=\"M0 0h7v26H0z\"/>","originalColors":[{"type":"fill","color":"#FF324B"}],"stopColors":[]}}
        
                    module.exports = data
                    